<template>
  <div
    v-if="activeArt && referenceStories.length > 0"
    class="frow column-start width-100 reference-stories"
  >
    <strong @click="showStories = !showStories">
      <i
        class="icon"
        :class="showStories ? 'ion-md-arrow-dropup' :'ion-md-arrow-dropdown'"
      />
      stories that talk about this art
    </strong>
    <ul v-if="showStories">
      <li
        v-for="s in referenceStories"
        :key="`ref-${s.id}`"
      >
        <a
          v-if="makeLinks"
          @click="$emit('setActiveStoryReference', s)"
        >
          {{ s.title }}
        </a>
        <span v-else>
          {{ s.title }}
        </span>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'StoryReferences',
  props: {
    activeArt: {
      type: Object,
      default: () => {}, 
    },
    activeStory: {
      type: Object,
      default: () => {}, 
    },
    stories: {
      type: Array,
      default: () => [],
    },
    makeLinks: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showStories: false,
    };
  },
  computed: {
    referenceStories() {
      let matchedStories = [];
      this.stories.forEach((s) => {
        if (
          (s.description && s.description.includes(`href="#art-${this.activeArt.id}"`) 
          && (this.activeStory && s.id != this.activeStory.id))
        ) {
          matchedStories.push(s);
        }
      });
      if (matchedStories.length == 1 && this.activeArt.stories.length < 1) {
        this.$emit('setActiveStory', matchedStories[0]);
      }
      return matchedStories;
    },
  },
};
</script>
<style scoped lang="scss">
.reference-stories {
  min-height: 100px;
  text-align: left;
}
strong {
  cursor: pointer;
  display: flex;
}
i {
  font-size: 25px;
  margin-left: -5px;
}
</style>
